export enum EmailStatus {
  PENDING = 'pending',
  ENQUEUED = 'enqueued',
  PROCESSING = 'processing',
  SENT = 'sent',
  CANCELED = 'canceled',
}
